//@Todo we will optimmize this, moved here because it was not working on product recommendation
$(window).on('load', function() {
    $(document).on('submit', '.product_form',addToCart);

    $('.mobile-empty-recommendation .recommended-products-mini').not('.slick-initialized').slick(getRecommendeProductsMiniCartSettings());
});
const GIFT_CART_VENDOR = "Rise.ai";
const PROD_TYPE_BUNDLE = "sets product";
const PROD_TAG = "make-product-title-one-size";
const PROD_TYPE_GWP = "GWP";
const getRecommendeProductsMiniCartSettings = () => {
    return {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
    }
}
var oldCart = null;

$(function() {
    $(document).ready(function() {
    if (window.location.hash === '#openCart') {
        minicartToggle('open');
    }
        // AVOID ONLY GWP ON CART

        checkGwpLefties();

        // END OF AVOID ONLY GWP ON CART
        /*============================================================================
        MINI CART functionality
        ==============================================================================*/
        $(document).on('click','.back-icon, .mini-cart-shaddow', function(e){
            e.preventDefault();
            minicartToggle();
        });

        $(document).on('click', '#header-cart-icon',function (e){
            e.preventDefault();
            minicartToggle('open');
        });
        //--Mini Cart Trash
        $(document).on('click', '.mini-cart__remove', function(e){
            e.preventDefault();
            $('.loading-mini-cart').removeClass('hide');
            $qtyParent = $(this).parents('.mini-cart__item');
            $qtyInput = $qtyParent.find('input');
            $qtyPrice = $qtyInput.attr('data-price');
            $qtyInput.val(0);
            removeCart($qtyInput);
        });

      //close minicart with escape
      $(document).keyup(function(e){
        if(e.which == 27 && !$('.mini-cart-shadow').hasClass('hide')) {
          minicartToggle();          
        }
      });

        //--Mini Cart Qty Buttons
        $('body').on('click', '.mini-cart__qty button', function(){
            $('.loading-mini-cart').removeClass('hide');
            let qtyDir = $(this).attr('class'),
                $qtyInput = $(this).siblings('input'),
                qtyPrice = $qtyInput.data('price'),
                $qtyParent = $qtyInput.parents('.mini-cart__item'),
                qtyVal = parseInt($qtyInput.val()),
                $addToCartForm = $('#mini_cart_form');

            qtyDir = qtyDir.split(' ',1)[0];

            qtyVal = (qtyDir === 'less' ? qtyVal-1 : qtyVal+1);

            $qtyInput.val(qtyVal);
            $qtyParent.find('.price').html('£'+Math.round((qtyPrice*qtyVal)));
            oldCart = $.getJSON('/cart.js')
            $.ajax({
                url: '/cart/update.js',
                dataType: 'json',
                type: 'post',
                data: $addToCartForm.serialize(),
                success: function(new_cart) {
                    handleGwp(new_cart);

                    $('.mini-cart__subtotal .mini-cart__sub-total').html('£'+Math.round((new_cart.total_price/100)));

                    if (qtyVal == 0) {
                        $qtyParent.remove();

                        const removedProduct =
                            oldCart.responseJSON.items.filter(i => new_cart.items.filter(x => i.variant_id == x.variant_id).length == 0)[0];
                        pushDataLayerRemoveEvent(removedProduct, oldCart.currency);
                    }
                    if ($('.mini-cart__item').length == 0){
                        $('.mini-cart__empty').removeClass('hide');
                    }
                    if(qtyVal == 0 && $('.mini-cart__item').length == 0 ){
                        hideWrapper();
                    }
                },
                error: function(XMLHttpRequest) {
                    let response = eval('(' + XMLHttpRequest.responseText + ')');
                    response = response.description;
                    $('.warning').remove();
                    let warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
                    $addToCartForm.after(warning);
                }
            });
        });


        $(window).on('orientationchange', function(event) {
      
            if (Number(window.orientation) === 90) {
                $('#mini_cart_form').nextAll().addClass('hide')
            } else {
                $('#mini_cart_form').nextAll().removeClass('hide')
            }
        });
    });

    $(document).on('click', '.add_btn' ,function(e){
        e.preventDefault();
        minicartToggle('open');
        $('.mini-cart-header').removeClass('empty-header');
        var pForm = $(this).parents('form');
        var btnval = $(this).val();
        $(this).attr('data-label', btnval);
        $('.loading-mini-cart').removeClass('hide');
        $(".minicart-hide-show").removeClass("hide ");
        setTimeout(function(){
            pForm.submit();
        },50)
    });

});

function hideWrapper(){
    $('.mini-cart__subtotal').addClass('hide');
    $('.mini-cart-header').addClass('empty-header'); 
}

var prevFocusedEl
function minicartToggle(state){
    if(state == 'open') {
        prevFocusedEl = $(':focus');
        $('.mini-cart__wrapper').addClass('mini-cart-slide');
        $('.mini-cart-shaddow').removeClass('hide');
        $('html, body').addClass('body-fixed');
        $('#miniCart').css('visibility','visible');
        setTimeout(() => {$('.back-icon').focus()}, 500);
    } else {
        window.location.hash = '';
        $('.mini-cart__wrapper').removeClass('mini-cart-slide');
        $('.mini-cart-shaddow').addClass('hide');
        $('html, body').removeClass('body-fixed');
        $('#miniCart').css('visibility','hidden'); 
        focusPrevEl()
    }
}

function focusPrevEl(){
    if(prevFocusedEl){
        //Focus product grid Link before Add to bag
        if(prevFocusedEl.parent('.product-card__add-to-cart-form').length){
            prevFocusedEl.parent().parent().parent().children().each((i,element)=>{
                
                if(element.tagName == "A"){
                    setTimeout(() => {
                        element.focus();
                    },50);
                } 
            })
        }
       setTimeout(() => {
           prevFocusedEl.focus();
       }, 250);
    }  
}

//  Add Loader text to button
//send data for tracking
function pushAddtoCartDataforTracking(handle) {
    $.ajax({
        url: '/products/' + handle + '.js',
        dataType: 'json',
        async: true,
        success: function(product){
            let variants = "";

            $.each(product.variants, function (vIndex, vItem) {
                variants += vItem.title
            });
            let productDetail = [{
                'name': product.title,
                'id': product.id,
                'quantity': 1,
                'price': product.price/100,
                'category': $('#collection_name').val(),
                'brand': product.vendor,
                'variant': variants,
                'addToCartType': 'button'
            }];

            dataLayer.push({
                'event': 'addToCart',
                'ecommerce': {
                    'currencyCode': 'GBP',
                    'add': {
                        'products': productDetail
                    }
                }
            });
        }
    });
}
//--Add to cart
function addToCart(e) {
    e.preventDefault();
    pushAddtoCartDataforTracking($(this).data('handle'));
    $('.loading-mini-cart').removeClass('hide');
    $('.shutter .close').trigger('click');
    window.btntxt = $(this).find('.add_btn').data('label');
    let $addToCartForm = $(this),
        $addToCartBtn = $addToCartForm.find('.add_btn');

    /* create new object for property */
    var newArr = [];
    var vId = '';
    var formid = '#'+$addToCartForm.attr('id')+" ";

    // CAN WE IMPROVE THIS TO NOT HAVE MCALL INSIDE A FOR ????
    $(formid+"*[id*='variantSelectMain_sb'] option:selected").each(function(index, val)
    {
        var lengthIndex = index+1;

        var property_value = $(formid+'#properties_'+lengthIndex).val();
        vId = $(this).val();
        $.ajax({
            url: '/products/' + property_value + '.js',
            dataType: 'json',
            async: false,
            success: function(product){
                $.each(product.variants, function (vIndex, vItem) {

                    if(vItem.id == vId)
                    {
                        var chargeDetails = {
                            name : product.handle,
                            variant : vId,
                            value : vItem.sku,
                            quantity : 1,
                            calculated_bundle_price : vItem.price/100,
                            product_title : product.title,
                            product_image : product.featured_image,
                            product_option : vItem.option1
                        };
                        newArr.push(chargeDetails);
                    }

                });
            }
        });
    });
    $(this).find('.variant_array').val(JSON.stringify(newArr));
    /* End create new object for propert */
    if ($addToCartBtn.find('span').hasClass('fadeIn') === true)   {
        window.location.href='/cart';
    } else {
        var dataToSubmit = $(this).serialize();
        if(typeof $(this).attr('id') !== "undefined" && $(this).attr('id').indexOf('bundle_items') > -1){
            if($(this).find('.variant_array').length < 1 || $(this).find('.variant_array').val() == ""){
                minicartToggle();
                var btn_attempt = $(this).find('button').attr('data-attempt')
                if(btn_attempt){
                    $('.something-wrong-popup').addClass('show-success-fail-popup');
                    $('body').addClass('overflowhidden');
                    return;
                } else {
                    $('.unsuccessful-popup').addClass('show-success-fail-popup');
                    var btn_id = $(this).find('button').attr('id');
                    $('#resubmit-cart').attr('data-id', btn_id);
                    $(this).find('button').attr('data-attempt', 2);
                    $('body').addClass('overflowhidden');
                    return;
                }
            }
        }
      minicartToggle('open');      
      oldCart = $.getJSON('/cart.js')
        $.ajax({
            url: '/cart/add.js',
            dataType: 'json',
            type: 'post',
            data: dataToSubmit,
            success: function(itemData) {
                //CODELESS GWP
                $.getJSON('/cart.js', function(new_cart) {
                    handleGwp(new_cart, false, false);
                    $addToCartBtn.val(btntxt).prop("disabled",false).removeAttr("disabled");
                });

                $('.mini-cart__empty').addClass('hide');
                $('.mini-cart__subtotal').removeClass('hide');
                $('.mini-cart-header').removeClass('empty-cart');
            },
            error: function(XMLHttpRequest) {
                var response = eval('(' + XMLHttpRequest.responseText + ')');
                response = response.description;
                $('.warning').remove();

                var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
                $addToCartForm.after(warning);
                $addToCartBtn.attr( "disabled", "disabled" );
                $addToCartBtn.val('Out of Stock');
            }
        });
    }

    return false;
}
//incase bundle properties missing
$(document).on('click', '#resubmit-cart',function (e){
    e.preventDefault();
    var btn_id = $(this).data('id');
    $('#'+btn_id).trigger('click');
    $('body').removeClass('overflowhidden');
    $('.unsuccessful-popup').removeClass('show-success-fail-popup');
});

$(document).on('click', '#reload-page',function (e){
    e.preventDefault();
    window.location.reload();
});

//--Refresh Cart
function refreshCart(cart) {
    let cartButton = $(".cart_button"),
        cartCount = cartButton.find('span'),
        cartText = cartButton.find('.cart_text'),
        cartIcon = `<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.3286 5.3803H12.598C12.598 3.49541 11.0275 1.96152 9.09645 1.96152C7.16733 1.96152 5.5958 3.49541 5.5958 5.3803H3.86523C3.86523 2.5412 6.21218 0.230957 9.09645 0.230957C11.9817 0.230957 14.3286 2.5412 14.3286 5.3803Z" fill="#202020"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.3232 7.30298L14.683 16.847H3.3962L1.75691 7.30298H0L1.93759 18.5775H16.1416L18.0782 7.30298H16.3232Z" fill="#202020"/>
        </svg>
        `;
    
  
    let cartCountHtml = '<span><span>(' + (cart.item_count)  + ')</span><span>';
    $('.cartCount').html(cartCountHtml);
    $(".minify-counter").html(cart.item_count +' Items');
    $("[data-cart-count]").html(cart.item_count);

    if(cart.item_count === 0) {
        $('.site-header__cart-count').addClass('hide');
        $('.cartCount').html(cartCountHtml);
        $('[data-cart-count]').html(cart.item_count);
        $('#mini-cart-empty-box').removeClass('hide');
        $('#mini-cart-header').addClass('empty-cart');
        $('#mini-cart__subtotal').addClass('hide');
        $(".minicart-hide-show").addClass("hide");
        if($('.mobile-empty-recommendation .empty-cart-recommedation .recommended-products-mini').length > 0){
            $('.mobile-empty-recommendation .empty-cart-recommedation .recommended-products-mini').not('.slick-initialized').slick(getRecommendeProductsMiniCartSettings());
        }
        $(".minicart-hide-show").removeClass("four-item-imgs");
        $('.loading-mini-cart').addClass('hide');

        sessionStorage.removeItem("gwp_remove");
        resetDiscountsession();
    } else if(cart.item_count <= 1)  {
        $(".minify-counter").html(cart.item_count +' Item');
    } else {
        var count = 0;
        for(var i = 0; i < cart.items.length; i++) {
            if(cart.items[i].vendor === "DailyKarma") {
                count+=1;
            }else {
                count+=cart.items[i].quantity;
            }
        }

        $('.cartCount').html('<span><span>(' + count + ')</span><span>');
        $('[data-cart-count]').html(count);
        cartText.html('Checkout');
    }

}

//Update Mini-Cart
var savings_price = 0;
function updateCart(cart) {
    if (cart.item_count > 0) {
        $('.site-header__cart-count').removeClass('hide');
        $('.mini-cart-empty-box').addClass('hide');
        $('.mini-cart__subtotal').removeClass('hide');
        $('.mini-cart-header').removeClass('empty-header');
        $(".minicart-hide-show").removeClass("hide");

    }

    let html = "",
        cartControl = "",
        itemImages = "",
        itemInfo = "",
        sample = "",
        salePrice = "",
        codeless_gwp_id = $('body').data('code-product');
    let nullImage = '//cdn.shopify.com/shopifycloud/shopify/assets/no-image-100-c91dd4bdb56513f2cbf4fc15436ca35e9d4ecd014546c8d421b1aece861dfecf_85x@2x.gif';
    let removeIcon = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect y="1.52158" width="2.15154" height="17.6426" transform="rotate(-45 0 1.52158)" fill="#CBC2AC"/> <rect x="12.479" width="2.15154" height="17.6426" transform="rotate(45 12.479 0)" fill="#CBC2AC"/> </svg>';
    let removeBtn = '<div class="remove-mini-cart-item"><a href="#" title="remove" class="mini-cart__remove font-solina-link" aria-label="remove from cart">'+ removeIcon +'</a></div>';

    var compare_price_total = 0;
    
    $.each(cart.items, function (index, item) {
        salePrice = "";
        let itemVariantInfo = '';
        let itemTitle = item.product_title;
        sample = item.product_type === "Sample Program" ? 'disabled' : '';

        if (itemTitle === "Gift Product" && item.image == null) {
            itemImages = '<div class="mincart-product-thumb"><img src="'+ nullImage +'" alt="'+ item.title +'"></div>';
        } else if (itemTitle === "Gift Product" ) {
            itemImages = '<div class="mincart-product-thumb giftthumb"><img src="'+ item.image +'" alt="'+ item.title +'"></div>';
        }

        if (item.image== null || item.image=="null" || item.image=="" ) {
            itemImages = '<div class="mincart-product-thumb"><img  src="'+ nullImage +'" alt="'+item.title+'"></div>';
        }  else {
            itemImages = '<a href="'+ item.url +'"><div class="mincart-product-thumb"><img  src="'+item.image+'" alt="'+item.title+'"></div></a>';
        }

        let product = getProduct(item.handle)
        let product_tags = product.tags
        let titlestring = "";
        let firstWord = "";

        let titlestring2 = "";
        let lastWords = itemTitle;
        if(item.vendor.toLowerCase() != GIFT_CART_VENDOR.toLowerCase()) {
            titlestring = itemTitle;
            firstWord = titlestring.split(" ")[0];

            titlestring2 = itemTitle;
            lastWords = titlestring2.substr(titlestring2.indexOf(" ") + 1);
        }

        if(product_tags.includes(PROD_TAG)) {
            firstWord = "";
            lastWords = itemTitle;
        }

        var classfreeGWP = ' ';
        var classbigName = ' ';
        if(item.product_type  === PROD_TYPE_GWP || item.price == 0){
            classfreeGWP = ' freeGWP ';
            if(item.title.length > 30){
                classbigName = ' bigName ';
            }
            itemImages = '<div class="mincart-product-thumb"><span class="mobile-minicart-badge font-public-p-12 uppercase">free</span><img  src="'+item.image+'" alt="'+item.title+'"></div>';
            itemInfo = '<div><h4 class="font-solina-heading-style-prod-heading-style-4">'+ firstWord +'</h4> <h4 class="font-solina-heading-style-prod-heading-style-2">'+lastWords+'</h4></div>';
            if(item.quantity == 1){
                cartControl = `<input type="hidden" id="quantity" name="updates[${item.id}]" class="quantity" value="1" data-loop="1" data-price="${Math.round((item.final_price/100))}" aria-label="quantity">`;   
            } else {
                cartControl = '<div class="mini-cart__qty font-solina-heading-style-3"><div class="min-cart-qty-input">'+  
                    '<button type="button" class="less font-solina-heading-style-3" aria-label="Quantity minus" disabled></button>'+
                    `<input readonly="" id="quantity" name="updates[${item.id}]" class="quantity font-solina-heading-style-3" value="${item.quantity}" data-loop="1" data-price="${Math.round((item.final_price/100))}" aria-label="quantity">`+
                    '<button type="button" class="more font-solina-heading-style-3" disabled aria-label="Quantity plus"></button>'+
                    '</div></div>';
            }
        }  else {
            itemInfo = '<a href="'+ item.url +'"><h4 class="font-solina-heading-style-prod-heading-style-4">'+ firstWord +'</h4> <h4 class="font-solina-heading-style-prod-heading-style-2">'+lastWords+'</h4></a>';
            let disabled = '';
            if ((item.final_line_price/100).toFixed(2) === '0.00') {
                disabled = 'disabled';
            }

            cartControl = '<div class="mini-cart__qty font-solina-heading-style-3"><div class="min-cart-qty-input">'+
                '<button type="button" class="less font-solina-heading-style-3" aria-label="Quantity minus">-</button>'+
                `<input readonly="" id="quantity" name="updates[${item.id}]" class="quantity font-solina-heading-style-3" value="${item.quantity}" data-loop="1" data-price="${Math.round((item.final_price/100))}" aria-label="quantity">`+
                '<button type="button" class="more font-solina-heading-style-3" aria-label="Quantity plus" '+sample+'>+</button>'+
                '</div></div>';
        }

        if(item.variant_title != null) {
            itemVariantInfo = '<p class="giftCartPrice">' + item.variant_title + '</p>';
        }

        if ((item.final_line_price/100).toFixed(2) == '0.00' && item.original_line_price == item.final_line_price) {
            itemPrice = '<span class="free-gifts__free font-solina-heading-style-2">'+'FREE'+"</span>";
        } else if ((item.final_line_price/100).toFixed(2) == '0.00' && item.original_line_price != item.final_line_price) {
            itemPrice = '<span class="free-gifts__free_getY font-solina-heading-style-2">'+'FREE'+"</span>";
        } else {
            itemPrice = '<span class="original-price font-solina-heading-style-2">'+'£'+Math.round((item.final_line_price/100))+"</span>";
        }
        
        if (item.original_line_price > item.final_line_price) {
            salePrice = '<span class="cut-price"> £'+ Math.round((item.original_line_price / 100)) +'</span>';
        }

        const isEmpty = item.properties ? Object.keys(item.properties).length === 0 : true;
        let compare_at_price = 0;
        let saleSum = "";
        let description = "";
        if(item.properties && !isEmpty) {
            if (item.properties.compare_at_price) {
                compare_at_price = JSON.parse(item.properties.compare_at_price);
                compare_at_price = (compare_at_price/100) * item.quantity
                compare_price_total = compare_price_total + compare_at_price;
                saleSum = compare_at_price;
            } else {
                compare_price_total = compare_price_total + (item.final_line_price / 100);
            }
        }
        
        itemInfo += `<input type="hidden" id="main_product_id_${item.handle}" name="main_product_id" value="${item.id}" />`;
        let discountedPrice;
        if (item.original_line_price > item.final_line_price) {
            discountedPrice = Math.round((item.original_line_price / 100));
            saleSum = discountedPrice;
            if(compare_at_price){
                saleSum = compare_at_price
            }
        }

        if (item.properties && item.properties.product_size !== undefined) {
            description = '<p class="mini-cart-small-desc font-public-p-14">' + item.properties.product_size.replace(/(<([^>]+)>)/gi, "") + '</p>';
        } else {
                // [techDeb]
                // THIS IS A FALLBACK WHEN AN ITEM IS MISSING METAFIELDS INFO IN THE PROPERTIES
                // MUST BE IMPROVED
                $.ajax({
                url: '/products/' + item.handle + '?view=json',
                type: 'get',
                async: false,
                success: function (itemData) {
                    if (itemData) {
                        var parseJson = $.parseJSON(itemData);
                        if (
                            parseJson.metafields.compare_at_price != null &&
                            compare_at_price === 0 &&
                            compare_price_total === 0
                        ) {
                                parseJson.metafields.compare_at_price
                            compare_price_total =
                                parseFloat(compare_price_total) +
                                parseFloat(
                                    (compare_at_price / 100) * item.quantity
                                )
                            saleSum = compare_at_price
                        } else {
                            compare_price_total =
                                parseFloat(compare_price_total) +
                                parseFloat(item.final_line_price / 100)
                        }
                        if (parseJson.metafields.product_size != null && description === "") {
                            description = '<p class="mini-cart-small-desc font-public-p-14">' + parseJson.metafields.product_size.replace(/(<([^>]+)>)/gi, "") + '</p>';
                        }
                    }
                }
            });
        }
        if(saleSum){
            salePrice = '<span class="cut-price"> £'+ saleSum +'</span>';
        }

        if(salePrice != ""){
            itemPrice = '<span class="price">'+ itemPrice + salePrice + '</span>';
        } else{
            itemPrice = '<span class="price normal-pricing original-price font-solina-heading-style-2">'+ itemPrice + '</span>';
        }

        itemInfo+=description;
        var hidegiftcardqty = "";
        if(item.vendor == GIFT_CART_VENDOR) {
            hidegiftcardqty = "giftCartQtyHide";
        }



        let subHtml = "";
        if(item.properties != null){
            if(item.properties.bundle_product != undefined && item.properties.bundle_product != ""){
                var bundle_obj = jQuery.parseJSON(item.properties.bundle_product);
                var comma = '';
                if(bundle_obj.length > 1){
                    comma = ', ';
                }
                $.each(bundle_obj, function (pIndex, pItem) {
                    var finalItem = pIndex + 1;
                    if(bundle_obj.length == finalItem){
                        comma = '';
                    }
                    let bundleItemTitle = pItem.product_title;
                    let bundleItemImages = '<div class="bundleItemImage"><img src="'+pItem.product_image+'" alt="'+pItem.product_title+'"></div>';
                    let bundleItemInfo = '<p class="commavalue font-public-p-14">'+bundleItemTitle + comma +'</p>';
                    let bundleVariantInfo = '';
                    if(pItem.product_option != 'Default Title'){


                        bundleVariantInfo = '<p class="bundle-variant-info">'+pItem.product_option+'</p>';
                    }

                    subHtml += '<div class="bundle-cart__item" data-title="'+pItem.product_title+'"><div class="bundle-cartinfo">' + bundleItemInfo +'</div></div>';

                });
            }}
        qtyClass = item.product_type  === PROD_TYPE_GWP ? item.quantity != 1 ? ' multiPleFreeItem ' : ' ' : ' ';
        html += '<div class="mini-cart__item ' + hidegiftcardqty + classfreeGWP + classbigName +'" data-title="'+item.title+'"><div class="mini-cart-inner-wrapper bundleWrap">';
        html += '<div class="mini-cart-left-col">';
        html += itemImages;
        html += '<div class="mini-cart__info"><div class="mini-cart_content">';
        html += itemInfo + itemVariantInfo ;
        html += '</div>';
        html += '</div></div>';
        html += '<div class="mini-cart-right-col"><div class="mini-cart-price-col">';
        html += item.variant_id != codeless_gwp_id ? removeBtn : '';
        html += '</div></div></div>';        
        html += item.properties != null && JSON.stringify(item.properties) !== '{}' && item.title != "Gift Product" && typeof item.properties.bundle_product != "undefined" && item.properties.bundle_product.length != 2 ? '<div class="bundleItemList font-public-p-14">Includes: '+subHtml+'</div>': '';
        html += '<div class="full-width-actions">';
        html += '<div class="mini-cart__qty-wrapper '+ qtyClass + '">'+ cartControl + '</div><div class="mini-cart-price">'+ itemPrice +'</div>'; 
        html += '</div>';
        html += '</div>';
    });
    html += '<div class="bottomBorderNone">&nbsp;</div>';
    html += '<input type="hidden" name="discount" id="promoToSubmit" value="'+$(".promoCodeInputToSubmit").val()+'" />';

    $('#mini_cart_form').html(html);

        // Count items in cart
    var getCartItemsCount = $('#mini_cart_form .mini-cart__item ').length;
    if(getCartItemsCount > 4) {
     $("#mini_cart_form").append('<div class="minicart-remaining"><div class="mini-cart-inner-wrapper"><span class="remainingItems font-solina-heading-style-4 font-weight-600"> +<span class="itemCount">'+parseInt(getCartItemsCount - 4)+'</span></span></div></div>');
    }
    
    var thenum = Math.round(cart.total_price/100)

    $('.estimatted-total h4').text('£'+thenum);
    $('.subtotal-price p').text('£'+compare_price_total);
    savings_price =  Math.round(compare_price_total) - Math.round(cart.total_price/100);
    
    let show_progress_bar = $("body").data("show-progress-bar");
   let shipping_threashold = $("body").data("free-exxpress-shipping-threshold");
   let totalcartcount = Math.round((cart.total_price/100));
   let totalcartcount_threashold = parseInt(shipping_threashold) - Math.round(parseInt((cart.total_price/100)));
   let thresholdPercentagAchieved = (totalcartcount / shipping_threashold) * 100;
    if(totalcartcount >= shipping_threashold ) {
       if(show_progress_bar) {
         $('.shipping-wrapper .cart-progress').css('width', '100%');
       }
       $('.shipping_text').text('Awesome, you earned free UK shipping!');
   } else {
        if(show_progress_bar) {
            $('.shipping-wrapper .cart-progress').css('width', `${thresholdPercentagAchieved}%`);
        }
      $('.shipping_text').text('Add £' +totalcartcount_threashold+ ' for free UK shipping');
   }
    refreshCart(cart);
}

//remove Item from cart
function removeCart($qtyParent, gwp_remove = false) {
    if ($('.mini-cart__item').length == 1 ){
        $('.mini-cart__subtotal').addClass('hide');
        $('.mini-cart-header').removeClass('.empty-header');
    }

    let $addToCartForm = $('#mini_cart_form');
    oldCart = $.getJSON('/cart.js')
    $.ajax({
        url: '/cart/update.js',
        dataType: 'json',
        type: 'post',
        data: $addToCartForm.serialize(),
        success: function(new_cart) {
            updateCart(new_cart);
            const removedProduct =
                oldCart.responseJSON.items.filter(i => new_cart.items.filter(x => i.variant_id == x.variant_id).length == 0)[0];
            pushDataLayerRemoveEvent(removedProduct, oldCart.currency);

            if(new_cart.item_count === 0){
                //@TODO handle this with gwp update call
                refreshCart(new_cart);
            } else {
                handleGwp(new_cart, false, true,);
                $('.mini-cart__subtotal .mini-cart__sub-total').html('£'+Math.round((new_cart.total_price/100)));

                if($("#mini_cart_form").children('.mini-cart__item').length > 0){
                    $('.mini-cart-empty-box').addClass('hide');
                    $('.mini-cart-empty-box').addClass('hide');
                    $('.mini-cart__subtotal').removeClass('hide');
                    $('.mini-cart-header').removeClass('empty-header');

                } else {
                    $('.mini-cart-empty-box').removeClass('hide');
                    $('.mini-cart-inner h4').text('MY BAG (0)');
                    hideWrapper();
                }

                $('.mini-cart__subtotal .mini-cart__sub-total').html('£'+Math.round((new_cart.total_price/100)));

                $qtyParent.remove();
                if ($('.mini-cart__item').length == 0){
                    $('.mini-cart__empty').removeClass('hide');
                }
            }
        },
        error: function(XMLHttpRequest) {
            let response = eval('(' + XMLHttpRequest.responseText + ')');
            response = response.description;
            $('.warning').remove();
            let warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
            const $addToCartForm = $('#mini_cart_form');
            $addToCartForm.after(warning);
        }
    });
}


// Safari Vh issue fixed
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);
window.addEventListener('resize', () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
});
  

    /*============================================================================
    FREE SAMPLE functionality
    ==============================================================================*/
    const checkGwpLefties = () => {
        const gwpProductOne = $("body").data("gwp-product-one");
        const gwpProductTwo = $("body").data("gwp-product-two");
        const gwpthresholdProductOne = $("body").data("gwp-threshold-product-one");
        const gwpthresholdProductTwo = $("body").data("gwp-threshold-product-two");
        const gwpthresholdValueOne = $("body").data("threshold-one");
		const gwpthresholdValueTwo = $("body").data("threshold-two");
        const getYHandle = $("body").data("buy-x-get-y-auto-add-product");
        const sampleHandles = [gwpProductOne, gwpProductTwo, gwpthresholdProductOne, gwpthresholdProductTwo,gwpthresholdValueOne,gwpthresholdValueTwo, getYHandle];       
        const productHandleList = $("body").data("buy-x-get-y-auto-add-products-list").split("|").map(i => i.trim());

        productHandleList.forEach((productHandle) => {
            buyXgetY = productHandle.split(",").map(i => i.trim());
            getYList = sampleHandles.push(buyXgetY[1]);
        })
        
        $.getJSON("/cart.js", function(cart) {
            const samplesInCart = cart.items.filter(i => sampleHandles.includes(i.handle));
            if (cart.item_count > 0) {
                $('.site-header__cart-count').removeClass('hide');
                if (cart.items.length <= samplesInCart.length) {
                    let finalObject = {};
                    samplesInCart.map(s => {
                        finalObject[parseInt(s.id)] = 0;
                    })
                    
                    $.ajax({
                        url: "/cart/update.js",
                        dataType: "json",
                        type: "post",
                        data: { updates: finalObject },
                        success: function(new_cart) {
                            handlePromoCode(new_cart);
                        },
                    });
                }
                if(cart.items.length) removeOldGwp(cart,sampleHandles);
            } else {
                refreshCart(cart);
            }
        });
    }
    
const updateCartGwps = (productsToAdd = [], productsToRemove = [], onComplete = () => {}) => {
    const itemsToAdd = productsToAdd.map(p => {
        const id = p.variants ? p.variants[0].id : p.id;
        const qty = p.quantity ? p.quantity : 1;
        const compare_at_price = p.compare_at_price ? p.compare_at_price : 0;
        var product_size = null;
        $.ajax({
            url: '/products/' + p.handle + '?view=json',
            type: 'get',
            async: false,
            success: function (itemData) {
                if (itemData) {
                    var parseJson = $.parseJSON(itemData);
                    if (parseJson.metafields.product_size != null) {
                        product_size = parseJson.metafields.product_size;
                    }
                }
            }
        });
        
        let properties = {};
        properties.product_size = product_size
        if(compare_at_price > 0 ){
            properties.compare_at_price = compare_at_price
        }
        return {
            id: id,
            quantity: qty,
            properties: properties
        } 
    })

    if(itemsToAdd.length > 0) { 
        $.ajax({
            url: '/cart/add.js',
            dataType: 'json',
            type: 'post',
            data: { items: itemsToAdd },
            success: function() {
                $.getJSON('/cart.js', function(new_cart) {
                    handlePromoCode(new_cart);
                    if (window.beautyLabsCart && window.beautyLabsCart.onIncoming) {
                        window.beautyLabsCart.onIncoming(new_cart);
                    }
                    $('.loading-mini-cart').addClass('hide');
                    onComplete();
                });
            },
            error: function() {
                onComplete()
            }
        })
    }

    const itemsToRemove = productsToRemove.map(p => {
        const id = p.variants ? p.variants[0].id : p.id;
        const qty = p.price > 0 ? p.quantity : 0;
        return {
            [id]: qty,
        }
    })

    if(itemsToRemove.length > 0) { 
        let data = {};
        Object.assign(data, ...itemsToRemove);
        $.ajax({
            url: '/cart/update.js',
            dataType: 'json',
            type: 'post',
            data: { updates: data },
            success: function(new_cart) {
                handlePromoCode(new_cart);
                if (window.beautyLabsCart && window.beautyLabsCart.onIncoming) {
                    window.beautyLabsCart.onIncoming(new_cart);
                }
                $('.loading-mini-cart').addClass('hide');
                onComplete();
            },
            error: function() {
                onComplete()
            }
        })
    }
}

const getCart = async () => {
    const request = await fetch("/cart.js");
    return await request.json();
};
function removeOldGwp(cart, samples) {
    let finalObject = {};
    cart.items.map(i => {
        if (i.price == 0 && !samples.includes(i.handle) && (!i.properties || i.properties['_showId'] === undefined || i.properties['_gwp'] === undefined)) {
            finalObject[parseInt(i.id)] = 0;
        }
    })
     
    $.ajax({
        url: "/cart/update.js",
        dataType: "json",
        type: "post",
        data: { updates: finalObject },
        success: function (new_cart) {
            handlePromoCode(new_cart);
            $('.loading-mini-cart').addClass('hide');
        },
    });

    addNewGwp(samples,cart)
}

function addNewGwp(samples,cart) {
    let [gwpOne,gwpTwo,thresholdGwpOne,thresholdGwpTwo,gwpthresholdValueOne,gwpthresholdValueTwo] = samples

    const giftCardItems = cart.items.filter(i => i.vendor === GIFT_CART_VENDOR);
    const samplesInCart = cart.items.filter(i => samples.includes(i.handle));
    const isAbleToGetFreeSample = (cart.items.length > (samplesInCart.length + giftCardItems.length));

    if (isAbleToGetFreeSample && samples) {
        let finalObject = {};
		gwpOne = gwpOne ? getProduct(gwpOne) : null;
		gwpTwo = gwpTwo ? getProduct(gwpTwo) : null;
		thresholdGwpOne = thresholdGwpOne ? getProduct(thresholdGwpOne) : null;
		thresholdGwpTwo = thresholdGwpTwo ? getProduct(thresholdGwpTwo) : null;
		const cartValue = cart.total_price/100;
        if (gwpOne) finalObject[parseInt(gwpOne.variants[0].id)] = 1
        if (gwpTwo) finalObject[parseInt(gwpTwo.variants[0].id)] = 1
        if ( thresholdGwpOne ) {
            if( cartValue >= gwpthresholdValueOne ) finalObject[parseInt(thresholdGwpOne.variants[0].id)] = 1
            else finalObject[parseInt(thresholdGwpOne.variants[0].id)] = 0
        }
        if( thresholdGwpTwo ){
            if( cartValue >= gwpthresholdValueTwo) finalObject[parseInt(thresholdGwpTwo.variants[0].id)] = 1
            else finalObject[parseInt(thresholdGwpTwo.variants[0].id)] = 0
        }
        
        $.ajax({
            url: "/cart/update.js",
            dataType: "json",
            type: "post",
            data: { updates: finalObject },
            success: function (new_cart) {
                handlePromoCode(new_cart);
                $('.loading-mini-cart').addClass('hide');
            },
        });
    }
}

const getProduct = productHandle => $.get({
    dataType: "json",
    url: `/products/${productHandle}.js`,
    async: false
}).responseJSON;

const handleNormalGwp = (cart, skipAdd) => {
    let returnObject = {
      itemsToAdd: [],
      itemsToRemove: []
    };

    const isAutoAddGwpEnabled = $("body").data("enable-gwpauto-add");
    if (isAutoAddGwpEnabled) {
        let samples = [];
        const gwpProductOne = $("body").data("gwp-product-one");
        const gwpProductTwo = $("body").data("gwp-product-two");
        const gwpthresholdProductOne = $("body").data("gwp-threshold-product-one");

        const gwpthresholdProductTwo = $("body").data("gwp-threshold-product-two");

        const getYHandle = $("body").data("buy-x-get-y-auto-add-product");

        const sampleHandles = [gwpProductOne, gwpProductTwo, gwpthresholdProductOne, gwpthresholdProductTwo, getYHandle];

        const thresholdProductOne = $("body").data("threshold-one");
        const thresholdProductTwo = $("body").data("threshold-two");

        const giftCardItems = cart.items.filter(i => i.vendor === GIFT_CART_VENDOR);

        const samplesInCart = cart.items.filter(i => sampleHandles.includes(i.handle));

        const isAbleToGetFreeSample = (cart.items.length > (samplesInCart.length + giftCardItems.length));

        if (isAbleToGetFreeSample) {
            const gwpThresholdOne = gwpthresholdProductOne ? getProduct(gwpthresholdProductOne) : null;
            const gwpThresholdTwo = gwpthresholdProductTwo ? getProduct(gwpthresholdProductTwo) : null;
            const cartTotal = cart.total_price / 100;
            let itemsToRemove = [];
            if (gwpThresholdOne) {
                if (cartTotal >= thresholdProductOne) {
                    if (!skipAdd) samples.push(gwpThresholdOne);
                } else {
                    itemsToRemove.push(gwpThresholdOne);
                }
            }
            if (gwpThresholdTwo) {
                if (cartTotal >= thresholdProductTwo) {
                    if (!skipAdd) samples.push(gwpThresholdTwo);
                } else {
                    itemsToRemove.push(gwpThresholdTwo);
                }
            }


            const gwpOne = gwpProductOne ? getProduct(gwpProductOne) : null;
            const gwpTwo = gwpProductTwo ? getProduct(gwpProductTwo) : null;

            if (gwpOne) {
                if (cartTotal > 0) {
                    if (!skipAdd) samples.push(gwpOne);
                }
                else {
                    itemsToRemove.push(gwpOne);
                }
            }
            if (gwpTwo) {
                if (cartTotal > 0) {
                    if (!skipAdd) samples.push(gwpTwo);
                }
                else {
                    itemsToRemove.push(gwpTwo);
                }
            }

            returnObject.itemsToAdd = samples.filter(s => s.available === true && !samplesInCart.find(i => i.product_id === s.id));
            returnObject.itemsToRemove = itemsToRemove.filter(s => samplesInCart.find(i => i.product_id === s.id));;
        } else {
            returnObject.itemsToRemove = samplesInCart;
        }
    }
    return returnObject;
}

const handleBuyxGetyAutoAdd = (cart, skipAdd) => {
    const isBuyXGetYEnabled = $("body").data("buy-x-get-y-auto-add-enabled");
    let returnObject = {
        itemsToAdd: [],
        itemsToRemove: []
    };

    if(isBuyXGetYEnabled){
        let samples = [];
        var buyXgetYList = {};
        var itemsToRemove = [];
        var samplesInCart = []
        const productHandleList = $("body").data("buy-x-get-y-auto-add-products-list").split("|").map(i => i.trim());
        const threshold = $("body").data("buy-x-get-y-auto-add-threshold");
        
        productHandleList.forEach((productHandle) => {
            let buyXgetY = productHandle.split(",").map(i => i.trim());
            buyXgetYList[buyXgetY[0]] = buyXgetY[1];
        })

        const allSamplesInCart = cart.items.filter(i => Object.values(buyXgetYList).includes(i.handle));

        for(var i=0; i < allSamplesInCart.length; i++){
            var found = false;
            var buyXProduct = Object.keys(buyXgetYList).find(key => buyXgetYList[key] == allSamplesInCart[i].handle)
            if( cart.items.filter( i => i.handle == buyXProduct).length > 0 ) { found = true }
            if( !found && allSamplesInCart[i].original_line_price == 0 ){ samplesInCart.push(allSamplesInCart[i]) }
        }

        for (var buyXhandle in buyXgetYList) {
            var getYHandle = buyXgetYList[buyXhandle];
            const isAbleToGetFreeSample = cart.items.filter(i => i.handle == buyXhandle);
            const getYProductInCart = cart.items.filter(i => i.handle == getYHandle);
            if (isAbleToGetFreeSample.length > 0) {  
                var buyXQty = isAbleToGetFreeSample[0].quantity;
                var getYQty = getYProductInCart.length > 0 ? getYProductInCart[0].quantity : 0;
                var oldBuyXQty = 0;
                if(oldCart.responseJSON) {
                    oldCart.responseJSON.items.forEach((item) => {
                        if(item.handle == buyXhandle) {
                            oldBuyXQty = item.quantity;
                        }
                    })
                }
                if(buyXQty > getYQty) {
                    const getYProduct = getYHandle ? getProduct(getYHandle) : null;
                    const cartTotal = cart.total_price / 100;
                    if (getYProduct) {
                        if (cartTotal > threshold) {
                            if (!skipAdd) samples.push(getYProduct);
                        } else {
                            itemsToRemove.push(getYProduct);
                        }
                    } else {
                        returnObject.itemsToRemove = samplesInCart;
                    }
                    returnObject.itemsToAdd = samples.filter(s => s.available === true);
                    returnObject.itemsToAdd.find((o, i) => {
                        if (o.handle === getYHandle) {
                            returnObject.itemsToAdd[i].quantity = buyXQty - getYQty;
                        }
                    });
                }
                else if (oldBuyXQty > buyXQty) {
                    const getYProduct = getYHandle ? getProduct(getYHandle) : null;
                    if (getYProduct) {
                        returnObject.itemsToRemove.push(getYProduct);
                        returnObject.itemsToRemove.find((o, i) => {
                            if (o.handle === getYHandle) {
                                returnObject.itemsToRemove[i].quantity = getYQty - 1;
                            }
                        });
                    }
                }
                //returnObject.itemsToRemove = itemsToRemove;
                } else {
                    if(samplesInCart.length > 0) {
                        returnObject.itemsToRemove = samplesInCart;
                    }
                }
        }
    }
    return returnObject;
}

function handleLiveShoppingGwp(cart) {
    let itemsToRemove = []

    $.each(cart.items, function (pIndex, pItem) {
        const properties = pItem.properties
        // If there are any GWP items from shows and we don't have another show item from the same show in the cart,
        // remove all GWP items with that ID (slightly overkill, but probably safe enough as we are doing this check
        // before the normal GWP checks, which could add them back in again (and you are unlikely to have the same GWP
        // from multiple shows)
        if (properties && properties['_showId'] !== undefined && properties['_gwp'] !== undefined) {
            if (cart.items.find(item => item.properties['_showId'] === properties['_showId'] && item.properties['_gwp'] === undefined) === undefined) {
                itemsToRemove.push(getProduct(pItem.handle))
            }
        }
    })

    return { itemsToRemove }
}

function handleGwp(cart, _callback = false, skipAdd = false, onComplete = () => {}, ) {
    const handleNormalGwpResult = handleNormalGwp(cart, skipAdd);
    const handleBuyXGetYAudoAddResult = handleBuyxGetyAutoAdd(cart, skipAdd);
    const handleLiveShoppingGwpResult = handleLiveShoppingGwp(cart)

    let items = handleNormalGwpResult;
    items.itemsToAdd = items.itemsToAdd.concat(handleBuyXGetYAudoAddResult.itemsToAdd);
    items.itemsToRemove = items.itemsToRemove.concat(handleBuyXGetYAudoAddResult.itemsToRemove).concat(handleLiveShoppingGwpResult.itemsToRemove);
    
    if (items.itemsToAdd.length > 0 || items.itemsToRemove.length > 0 ) {
        updateCartGwps(items.itemsToAdd, items.itemsToRemove, onComplete);
    } else {
        handlePromoCode(false, _callback);
        if (window.beautyLabsCart && window.beautyLabsCart.onIncoming) {
            window.beautyLabsCart.onIncoming(cart);
        }
        onComplete();
    }
};

window.beautyLabsCart = window.beautyLabsCart || {}
window.beautyLabsCart.onOutgoing = (cart) => {
    // Add/remove gwp and keep the minicart in sync
    oldCart = $.getJSON('/cart.js')
    handleGwp(cart);
}
window.beautyLabsCart.showMinicart = () => {
    // Show loading indicator
    // As showMinicart is only called before adding something to bag,
    // we know that this loading class will eventually get removed
    // either in the function body of handleGwp or in updateCartGwps
    $('.loading-mini-cart').removeClass('hide');

    if(!$('#pageWrapper').hasClass('open')) {
        minicartToggle('open');
    }
}

    /*============================================================================
    end of FREE SAMPLE functionality
    ==============================================================================*/
    
const pushDataLayerRemoveEvent = (cartLineItem, currency) => {
    dataLayer.push({
        'event': 'removeFromCart',
        'ecommerce': {
            'currencyCode': currency,
            'remove': {
                'products': [
                    {
                        'name': cartLineItem.product_title,
                        'id': cartLineItem.product_id,
                        'quantity': cartLineItem.quantity,
                        'price': cartLineItem.price,
                        'category': cartLineItem.product_type, //'[[PRODUCT CATEGORY]]',
                        // 'coupon': '[[PRODUCT COUPON]]',
                        'brand': cartLineItem.vendor, // Product level parameter that should contain the brand of the product in Enhanced E-Commerce; Not to be confused with a site level parameter, which is also known as 'brand'
                        'variant': cartLineItem.variand_id,
                        // 'productRange': '[[PRODUCT RANGE]]', // This parameter should contain the Product Range 'productSubCategory' '[[PRODUCT SUBCATEGORY]]'
                    }
                ]
            }
        }
    });
}
function pushDataforProductClick(handle) {
    $.ajax({
        url: '/products/' + handle + '.js',
        dataType: 'json',
        async: true,
        success: function(product){
            let variants = "";
            let options = [];
            $.each(product.variants, function (vIndex, vItem) {
                variants += vItem.title
                options = options.concat(vItem.options);
            });
            let productDetail = [{
                'name': product.title,
                'id': product.id,
                'quantity': 1,
                'price': product.price,
                'category': $('#collection_name').val(),
                'brand': product.vendor,
                'variant': variants,
                'productRange': options
            }];
            dataLayer.push({
                'event': 'productClick',
                'ecommerce': {
                    'currencyCode': 'GBP',
                    'click': {
                        'products': productDetail
                    }
                }
            });
        }
    });
}
    
$('.productClickDatalayer').click(function() {
    pushDataforProductClick($(this).data('handle'));
});